import App from "./App";
import Home from "./Home";
import Auth from "./Auth";
import Recover from "./panel/auth/Recover";
import Contact from "./Contact";
import Schedule from "./Schedule";
import Affiliate from "./Affiliate";
import Complaint from "./Complaint";
import Articles from "./Articles";
import Article from "./Article";
import Simulator from "./Simulator";
import Planificador from "./Planificador";
import SimulatorHighcharts from "./lib/SimulatorHighcharts";
import Certifications from "./Certifications";
import OurWay from "./OurWay";
import Cybersecurity from "./Cybersecurity";
import ReceivedStatement from "./ReceivedStatement";
import OurTeam from "./OurTeam";
import Login from "./panel/auth/Login";
import CreatePassword from "./panel/auth/CreatePassword";
import CreateAccount from "./panel/auth/CreateAccount";
import VerifyAccount from "./panel/auth/VerifyAccount";
import VeryfySms from "./panel/auth/VeryfySms";
import Questionary from "./panel/auth/Questionary";
import NewEMail from "./panel/auth/NewEMail";

window.App = App;
window.Home = Home;
window.Auth = Auth;
window.Recover = Recover;
window.Contact = Contact;
window.Schedule = Schedule;
window.Affiliate = Affiliate;
window.Complaint = Complaint;
window.Articles = Articles;
window.Article = Article;
window.Simulator = Simulator;
window.Planificador = Planificador;
window.SimulatorHighcharts = SimulatorHighcharts;
window.Certifications = Certifications;
window.OurWay = OurWay;
window.Cybersecurity = Cybersecurity;
window.ReceivedStatement = ReceivedStatement;
window.OurTeam = OurTeam;
window.Login = Login;
window.CreatePassword = CreatePassword;
window.CreateAccount = CreateAccount;
window.VerifyAccount = VerifyAccount;
window.VeryfySms = VeryfySms;
window.Questionary = Questionary;
window.NewEMail = NewEMail;
